import React from 'react';
import { DateObject } from '@uplift/services';


export const CalendarTitle: React.FC<{ date: DateObject; withDate?: boolean }> = ({ date, withDate = false }) => {
  const monthFormatted = date.format('MMMM');
  const dateFormatted = withDate ? date.format('D,') : undefined;
  const yearFormatted = date.format('YYYY');

  return (
    <>
      <span className="fc-toolbar-title-month">{monthFormatted} {dateFormatted}</span> <span className="fc-toolbar-title-year">{yearFormatted}</span>
    </>
  );
};
